// NetworkErrorContext.js

import { createContext, useState, useContext } from 'react';

const NetworkErrorContext = createContext();

export const useNetworkError = () => useContext(NetworkErrorContext);

export const NetworkErrorProvider = ({ children }) => {
  const [internetError, setInternetError] = useState(false);

  return (
    <NetworkErrorContext.Provider value={{ internetError, setInternetError }}>
      {children}
    </NetworkErrorContext.Provider>
  );
};

export default NetworkErrorContext;
